import axios from 'axios';
import _ from 'lodash';

export const filePondDeleteMethod =  (source, load, error) => {

    if (_.isNull(source) || _.isUndefined(source) || source == '') {
        return console.error('file-delete: nothing to delete');
    }

    // Should send `source` to server so server can remove the file with this source
    axios(
        {
            method: 'DELETE',
            url: `/files/upload/${source}`,
        }
    ).then(
        result => {
            // Should call the load method when done, no parameters required
            load();
        }
    ).catch(
        err => {
            // Can call the error method if something is wrong, should exit after
            error('oh no!');
        }
    )
};
